let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hjSai")).then(() => parcelRequire('67Wxi'));